import React, {useState, useEffect} from 'react';


import Icon from './../basic-icon';
import './index.less';

import * as Api from './../../api';

const viewUrl = Api.baseUrl + 'ciqafile/view/'
export default (props) => {
    const [menu, setMenu] = useState([]);
    useEffect(() => {
        Api.getMenuList().then(data => {
            setMenu(data);
            props.onLoadMenu(data);
            console.log(data);
        });
    }, []);

    return (
        <div className="menu">
            <ul>
                {
                    menu.map((item, index) => {
                        return <li key={index}>
                             <a href={`/#/news/${item.id}`}>
                                <span>{item.label}</span>
                                <span style={{marginLeft :15}}>{item.isHot == 1 ? <Icon type="icon-hot-fill left-icon"></Icon>:''}</span>
                            </a>
                            <ul>
                            {
                                (item.children || []).map((d, i) => {
                                    let label = d.label
                                    if(label == '联盟介绍'){
                                        return (
                                            <li key={i}>
                                                <a href={'/#/view/'+147}>{d.isHot == 1 ? <Icon type="icon-hot-fill icon"></Icon>:''}{d.label}</a>
                                            </li>
                                        )
                                    }else if(label =='联盟章程'){
                                        return (
                                            <li key={i}>
                                                <a href={'/#/view/'+145}>{d.isHot == 1 ? <Icon type="icon-hot-fill icon"></Icon>:''}{d.label}</a>
                                            </li>
                                        )
                                    }else if(label == '组织结构'){
                                        return (
                                            <li key={i}>
                                                <a href={'/#/view/'+146}>{d.isHot == 1 ? <Icon type="icon-hot-fill icon"></Icon>:''}{d.label}</a>
                                            </li>
                                        )
                                    }else if(label == '秘书处'){
                                        return (
                                            <li key={i}>
                                                <a href={'/#/view/'+150}>{d.isHot == 1 ? <Icon type="icon-hot-fill icon"></Icon>:''}{d.label}</a>
                                            </li>
                                        )
                                    } else{
                                        return (
                                            <li key={i}>
                                                <a href={`/#/news/${d.id}`}>
                                                <span>{d.isHot == 1 ? <Icon type="icon-hot-fill right-icon"></Icon>:''}</span>
                                                <span>{d.children ? <Icon type="icon-arrow-right"></Icon> : ""}</span>
                                                {d.label}</a>
                                                {
                                                    d.children ? (
                                                        <ul>
                                                            {
                                                                (d.children||[]).map((item, i) => (
                                                                    <li key={i}> 
                                                                        <a href={`/#/news/${item.id}`}> {item.isHot == 1 ? <Icon type="icon-hot-fill"></Icon>:''}{item.label}</a>
                                                                    </li>
                                                                ))
                                                            }
                                                            
                                                            <li><a onClick={() => {
                                                                const children = (d.children || []).map(item => ({
                                                                    key: item.id,
                                                                    value: item.id,
                                                                    label: item.label
                                                                }));
    
                                                                props.onPublish({
                                                                    label: d.label,
                                                                    children: d.children.map(item => ({
                                                                        key: item.id,
                                                                        value: item.id,
                                                                        label: item.label
                                                                    }))
                                                                });
                                                            }}>发布信息</a></li>
                                                        </ul>
                                                    ) : ""
                                                }
                                                
                                            </li>
                                        )
                                    }
                                })
                            }
                            <li><a onClick={() => {
                                const children = (item.children||[]).map(item => ({
                                    key: item.id,
                                    value: item.id,
                                    label: item.label
                                }));

                                props.onPublish({
                                    label: item.label,
                                    children: (item.children||[]).map(item => ({
                                        key: item.id,
                                        value: item.id,
                                        label: item.label
                                    }))
                                });
                            }}>发布信息</a></li>
                            </ul>
                        </li>
                    })
                }
            </ul>
        </div>
    );
}